import { ArrowUpBoldBoxOutlineIcon } from './ArrowUpBoldBoxOutlineIcon';

/**
 * author: Austin Andrews
 * id 5386BD1B-8959-4312-8739-5B08021F319D
 * name arrow-up-bold-box-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-box-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldBoxOutlineIcon = ArrowUpBoldBoxOutlineIcon;
export default ArrowTopBoldBoxOutlineIcon